<template>
  <TrainingProcessLog
    :extra-params="extraParams"
    :visible="visible"
    :extra-id="$attrs['extra-id']"
    api-url="/workspace/manager/training/resultVerify/resultProcessLog"
    log-type-name="成果" />
</template>

<script>
import TrainingProcessLog from '../../common/TrainingProcessLog'
export default {
  name: 'TrainingResultVerifyProcessLog',
  components: {
    TrainingProcessLog
  },
  props: {
    extraParams: Object,
    visible: Boolean
  }
}
</script>
